import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  ListOTSalaryComponentsResponse,
  ListOTSalaryComponentsQueryVariables,
} from '../types';

const listSalaryComponentsQuery = gql`
  query OvertimeListSalaryComponents(
    $status: OTSalaryComponentStatus
  ) {
    overtimeListSalaryComponents(status: $status) {
      code
      success
      message
      data {
        source
        salaryComponents {
          id
          name
          displayName
          description
          category
          isActive
          componentType
          componentSpace
          tenantId
          createdAt
          updatedAt
          settings {
            pfBehaviour {
              includeInPfWages
            }
            ptBehaviour {
              includeInPtWages
            }
            esiBehaviour {
              includeInEsiWages
            }
            lwfBehaviour {
              includeInLwfWages
            }
            gratuityBehaviour {
              includeInGratuityWages
            }
            leaveEncashmentBehaviour {
              includeInLeaveEncashmentWages
            }
            taxBehaviour {
              taxExemptionSection
              taxDeductionBehaviour
              taxExemptInNewRegime
              taxExemptInOldRegime
            }
            arrearBehaviour {
              considerInArrear
            }
            prorationBehaviour {
              supportProration
            }
            displayBehaviour {
              showZero
              visibleToEmployee
            }
          }
        }
        totalCount
      }
    }
  }
`;

const listSalaryComponents = (queryVariables?: ListOTSalaryComponentsQueryVariables) => {
  return graphQLApi<ListOTSalaryComponentsResponse, ListOTSalaryComponentsQueryVariables>({
    query: listSalaryComponentsQuery,
    queryVariables: queryVariables ?? {},
  });
};

export default listSalaryComponents;
